import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AsyncPipe, NgClass, NgForOf, NgIf } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';
import { CategoryWithoutItems } from '@us/web/shared/data-access';
import { Observable } from 'rxjs';
import { CategoriesStore } from '@us/web/categories/data-access';
import { ProductsComponent } from '../../pages/products/products.component';
import { TuiLoaderModule } from '@taiga-ui/core';
import {selectCategoryScrollList} from "@us/web/shop/data-access";
import {Store} from "@ngrx/store";

@Component({
    selector: 'us-categories',
    standalone: true,
    imports: [TranslocoModule, AsyncPipe, NgClass, NgForOf, ProductsComponent, NgIf, TuiLoaderModule],
    templateUrl: './categories.component.html',
    styleUrls: ['./categories.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CategoriesComponent {
    private readonly categoriesStore = inject(CategoriesStore);
    private readonly store = inject(Store);
    readonly isScrollList = this.store.selectSignal(selectCategoryScrollList);

    readonly isLoading$: Observable<boolean> = this.categoriesStore.isLoading$;
    readonly categories$: Observable<CategoryWithoutItems[]> = this.categoriesStore.categoriesWithoutItems$;
    readonly selectedCategory$: Observable<CategoryWithoutItems | null> = this.categoriesStore.selectedCategory$;

    onClickCategory(category: CategoryWithoutItems) {
        this.categoriesStore.selectCategory(category);
    }
}
